import styled from 'styled-components';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function ParkingAdminHeader() {
  const [remainingTime, setRemainingTime] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const token = sessionStorage.getItem('token');
    if (!token) return;

    const getExpiration = () => {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        return payload.exp * 1000; // ms 변환
      } catch (error) {
        return null;
      }
    };

    const updateRemainingTime = () => {
      const exp = getExpiration();
      if (!exp) return;

      const now = Date.now();
      const diff = exp - now;
      if (diff <= 0) {
        setRemainingTime('만료됨');
      } else {
        const minutes = Math.floor(diff / 1000 / 60);
        const seconds = Math.floor((diff / 1000) % 60);
        setRemainingTime(`${minutes}분 ${seconds}초`);
      }
    };

    updateRemainingTime();
    const timer = setInterval(updateRemainingTime, 1000);

    // eslint-disable-next-line consistent-return
    return () => clearInterval(timer);
  }, []);

  return (
    <>
      <HeaderContainer>
        <HeaderBox>
          <HeaderTitle>주차장 관리</HeaderTitle>
          <LastingTime>남은시간: {remainingTime}</LastingTime>
        </HeaderBox>
        <UserManual onClick={() => navigate('/parking/admin/detail')}>
          사용법 확인
        </UserManual>
      </HeaderContainer>
    </>
  );
}

const HeaderContainer = styled.div`
  height: 52px;
  background: #fff;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const HeaderBox = styled.div`
  display: flex;
  gap: 14px;
`;

const HeaderTitle = styled.div`
  color: var(--Font-02_black, #111);
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px; /* 140% */
  letter-spacing: -0.5px;
`;
const LastingTime = styled.div`
  display: inline-flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 24px;
  border: 1px solid #f1f1f1;

  color: #111;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
  letter-spacing: -0.3px;
`;

const UserManual = styled.button`
  color: #505050;
  text-align: right;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 146.667% */
  letter-spacing: -0.375px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;

  cursor: pointer;
`;
